const name = "@perxis-auto/instock-sdk";
export {
  name
};
